<template>
    <div class="mapdetail">
        <m-title :titlelist="listitem"></m-title>
        <div class="map-title" v-if="!this.positioncar">
            <div>
                <input type="text" placeholder="请输入车牌" v-model="inpval" class="inp">
                <button class="search" :disabled="!inpval" @click="getmapinfo">搜索</button>
            </div>
            <div v-if="$route.query.obj" style="font-size: 70%; color: #ff2b1e;">
                日期：{{ pnoInfo.time }}
                车队：{{ pnoInfo.shortname }}
                计划：{{ pnoInfo.pno }}
                车队车数：{{ pnoInfo.carRegistCount }}
                预派车数：{{ pnoInfo.yuyueCarCount }}
                派车数：{{ pnoInfo.dispathCount }}
                实际运输车数：{{ pnoInfo.carWorkedCount }}
                预派车兑现率：{{ (pnoInfo.yuyueCarRate*100).toFixed(2)}}%
                实际派车兑现率：{{ (pnoInfo.dispathRate*100).toFixed(2) }}%
            </div> 
            <!-- <button class="search1"  @click="getFenceDataTimer">重置</button> -->
        </div>
        <div id="container" :style="!this.positioncar ? 'height:calc(100% - 130px)' : 'height:calc(100% - 50px)'"></div>
        <div class="platelist" v-if="platelist.length>0">
            <ul style="display: flex;list-style: none;flex-direction: column;color: green;font-size: 90%;padding: 0;margin: 0;">
                <li @click="getplate(item.plate,index)" class="liclass" :style="indexactive===index?'background: #EEF7F6;':''" v-for="(item,index) in platelist" :key="index">{{ item.plate }}</li>
            </ul>
        </div>
    </div>
</template>

<script>
import mTitle from "@/components/mTitle";
import AMapLoader from "@amap/amap-jsapi-loader";
import dayjs from "dayjs";
import coordtransform from "coordtransform"
const plate_re = new RegExp('^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$');
const plate_re_xin = new RegExp(
    '[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF])|([DF][A-HJ-NP-Z0-9][0-9]{4}))');
export default {
    components: {
        mTitle
    },
    data() {
        return {
            listitem: [{ name: "地图" }],
            inpval: "",
            carlist: [],
            energylist: [],
            gapStationlist: [],
            searchlist: [],
            map: null,
            lat: 38.969557,
            lng: 117.769324,
            searchinfo: {},
            positioncar: JSON.parse(sessionStorage.getItem('positioncar')),
            intervalTime: null,
            markers: [],
            infoWindow:null,
            platelist:[],
            fleetname:"",
            pno:"",
            indexactive:"",
            pnoInfo:{}
        }
    },
    created() {

        if(this.$route.query.obj){
            this.fleetname=JSON.parse(this.$route.query.obj).shortname
            this.pno=JSON.parse(this.$route.query.obj).pno
            // this.getplatelist(this.$route.query.fleetname,this.$route.query.pno)
            this.pnoInfo=JSON.parse(this.$route.query.obj)
        }
    },
    mounted() {

        if (!this.positioncar) {
            this.getFenceData(true);
            this.intervalTime = setInterval(this.getFenceDataTimer, 30000)
        } else {
            this.lat = this.positioncar.lat
            this.lng = this.positioncar.lng
            this.carMap()
        }
    },
    beforeDestroy() {
        clearInterval(this.intervalTime)
        sessionStorage.removeItem('positioncar')
    },
    methods: {
       
       async getplatelist(fleetname,pno){
            this.searchlist = []
            const { data } = await this.$http(
                "api1",
                "driver/dispatchtruck/getPlateByPno",
                "get",
                {
                    fleetname,
                    pno
                }
            )
            if(data.code!==0) return this.$message(data.msg)
            if(data.data.length==0) return this.$message('车辆离线，暂无数据！')
            data.data.forEach(item => {
                item.icon = require("/public/homeImg/icon_red.png")
            })
            this.platelist=data.data
            this.arrEach([...this.platelist])
            // this.lat = data.data.mapEnergyCarVoList.lat
            // this.lng = data.data.mapEnergyCarVoList.lng
            setTimeout(() => {
                this.setLocation();
                // if(this.inpval){
                //     this.infoWindow.open(this.map)
                // }
                
            }, 500)
        },
        getplate(plate,index){
            this.indexactive=index
            this.inpval=plate
            this.getmapinfo()
            // let event=new Event('click')
            // this.getsearchinfo(event,this.inpval)
            
        },
        getFenceData(init) {
            if (init) {
                this.initMap();
            }
            // this.getmapinfo();
            this.getplatelist(this.fleetname,this.pno)
        },
        getFenceDataTimer() {
            // this.inpval=""
            // this.getmapinfo();
            this.getplatelist(this.fleetname,this.pno)
        },
        initMap() {
            AMapLoader.reset()
            AMapLoader.load({
                key: "e1e067886b395ac1aa709c2dd9982e7a", // 申请好的Web端开发者Key，首次调用 load 时必填
                version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
                plugins: [""], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
            })
                .then((AMap) => {
                    this.map = new AMap.Map("container", {
                        center: [117.8490190362603, 38.95143185123037],
                        zoom: 11,
                        // mapStyle: "amap://styles/darkblue",
                    });
                    var trafficLayer = new AMap.TileLayer.Traffic({
                        zIndex: 10,
                    });
                    this.map.add(trafficLayer);

                })
                .catch((e) => {
                    console.log(e);
                });
        },
        setLocation() {
            // 渲染多个坐标点
            this.markers.forEach(item => {
                this.map.remove(item);
            })
            this.markers = [];
            window.Drivings = (plate,startTime,endTime,pno) => {
                this.Drivings(plate,startTime,endTime,pno);
            };
            let that=this
            this.searchlist.forEach(val => {
                // var markerContentstyle = `<div class="custom-content-marker" style='background-image:url(${val.icon});width:40px;height:20px;border-radius:0;z-index: -1;'>`;
                //     const markerContent = markerContentstyle + ` <div class='pop-layer'> 
				// 				<span class='plate'>车牌号码:${val.plate}</span> 
				// 				<span class='plate'>所属车队:${val.shortname}</span> 
				// 				<span class='status'>车辆状态:${val.vehstate }</span>
				// 				<span class='plate'>充电状态:${val.chargestate}</span> 
				// 		</div>
				// 	</div>`
                var markerContentstyle =val.cartype? `
					<div class="map-info" style="font-size:80%;padding:10px 25px 10px 10px">
						<div class="info-item" style="margin-bottom: 10px;">
						<span>车牌号:</span>
						<span>${val.title || "--"}</span>
						</div>
						<div class="info-item" style="margin-bottom: 10px;">
						<span>车辆状态:</span>
						<span>${val.vehstate || "--"}</span>
						</div>
                        <div class="info-item" style="margin-bottom: 10px;">
						<span>剩余电量:</span>
						<span>${val.soc || "--"}%</span>
						</div>
						<div class="info-item" style="margin-bottom: 10px;">
						<span>车辆类型:</span>
						<span>${val.cartype || "--"}</span>
						</div>
						<div class="info-item" style="margin-bottom: 10px;">
						<span>排放标准:</span>
						<span>${val.discharge || "--"}</span>
						</div>
						<div class="info-item" style="margin-bottom: 20px;">
						<span>所属车队:</span>
						<span>${val.shortname || "--"}</span>
						</div>
						<div class="line"></div>
						<el-button type="primary" 
                       style="background: linear-gradient(0deg, #28C0C7 0%, #33D9A4 100%); border-radius: 5px;cursor: pointer; color: #fff;padding: 5px 10px;font-size: 14px;" onClick="Drivings('${val.title}','${val.startworkdate}','${val.endworkdate}','${that.pno}')">查看车辆轨迹 ></el-button>
					</div>
				`:'';

                // if (!this.map) return
                let position
                if(val.belongCarFactory=='吉利'){
                    position = new AMap.LngLat(val.position[0], val.position[1]); // Marker经纬度
                }else{
                    position=coordtransform.wgs84togcj02(val.position[0], val.position[1])
                }
                 
                const marker = new AMap.Marker({
                    position: position,
                    // content: markerContent, // 将 html 传给 content
                    icon: val.icon,
                    // title: val.cartype?`${val.title || "--"}
                    // 车牌号：${val.title || "--"}   车辆状态:${val.vehstate || "--"}
                    // 剩余电量：${val.soc || "--"}%   车辆类型:${val.cartype || "--"}
                    // 排放标准:${val.discharge || "--"}   所属车队:${val.shortname || "--"}
                    // `:`${val.title || "--"}`,
                    title:val.title

                });
                this.markers.push(marker);

                this.map.add(marker);
                 const infoWindow = new AMap.InfoWindow({
                    position: position,
                    // offset: new AMap.Pixel(20, -10),
                    content: markerContentstyle
                });
                let _this = this
                this.infoWindow=infoWindow
                marker.on("click", function () {
                    infoWindow.open(_this.map);
                   
                });
                // this.map.setFitView(null, false);
            });
        },
        async getmapinfo() {
            if (plate_re.test(this.inpval) || plate_re_xin.test(this.inpval)) {
                let index=this.platelist.findIndex(item=> item.plate==this.inpval)
                if(index===-1)return this.$message('该车不在此计划中')
            }else{
              return this.$message("请输入正确车牌号")
        }
       this.carlist= this.platelist.filter(item=> item.plate==this.inpval)
            this.searchlist = []
            // const { data } = await this.$http(
            //     "api1",
            //     "home/statistics/mapdisplay",
            //     "get",
            //     {plate:this.inpval}
            // )
            // data.data.energyStationDetailVoList.forEach(item => {
            //     item.icon = require("/public/homeImg/icon_cdz.png")
            // })
            // data.data.gapStationDetailVoList.forEach(item => {
            //     item.icon = require("/public/homeImg/icon_jqz.png")
            // })
            this.carlist.forEach(item => {
                item.icon = require("/public/homeImg/icon_truck_blue.png")
            })
            // this.gapStationlist = data.data.gapStationDetailVoList 
            // this.carlist = data.data.mapEnergyCarVoList
            // this.energylist = data.data.energyStationDetailVoList
            this.arrEach([...this.carlist])
            this.lat = this.carlist.lat
            this.lng = this.carlist.lng
            setTimeout(() => {
                this.setLocation();
                if(this.inpval){
                    this.infoWindow.open(this.map)
                }
                
            }, 500)

            // this.initAMap()
        },
        arrEach(arr) {
            return arr.forEach(item => {
                let obj = {
                    position: [],
                    title: "",
                    icon: "",
                }
                obj.position[0] = item.lng
                obj.position[1] = item.lat
                obj.title = item.locationName ? item.locationName : item.plate
                obj.icon = item.icon
                obj.vehstate = item.vehstate ? item.vehstate : ''
                obj.soc = item.soc ? item.soc : ''
                obj.cartype = item.cartype ? item.cartype : ''
                obj.discharge = item.discharge ? item.discharge : ''
                obj.shortname = item.shortname ? item.shortname : ''
                obj.belongCarFactory=item.belongCarFactory?item.belongCarFactory:''
                obj.startworkdate=item.startworkdate?this.mydateFormat(item.startworkdate,'时分秒'):''
                obj.endworkdate=item.endworkdate?this.mydateFormat(item.endworkdate,'时分秒'):dayjs(new Date().getTime()).format('YYYY-MM-DD HH:mm:ss')
                this.searchlist.push(obj)
            })
        },
        getsearchinfo(e,plate) {
            if(plate){
                this.inpval=plate
            }
                this.searchinfo = this.searchlist.find(item => {
                    return item.title == this.inpval
                })
                if (plate_re.test(this.inpval) || plate_re_xin.test(this.inpval)) {
                    if (this.searchinfo) {
                        this.lng = this.searchinfo.position[0]
                        this.lat = this.searchinfo.position[1]
                        this.searchlist.forEach(item => {
                            if (item.title == this.inpval) {
                                item.icon = require("/public/homeImg/icon_truck_blue.png")
                            }
                        })
                        this.map.add(this.searchlist)
                        this.setLocation()
                        setTimeout(() => {
                            // if(this.inpval){
                                this.infoWindow.open(this.map)
                            // }
                            
                        }, 500)
                        // this.infoWindow.open(this.map)
                        // this.setLocation()
                        // this.inpval = ""
                    } else {
                        this.$message("请输入正确名称")
                    }
                } else {
                    if (this.searchinfo) {
                        this.lng = this.searchinfo.position[0]
                        this.lat = this.searchinfo.position[1]
                        this.searchlist.forEach(item => {
                            if (item.title == this.inpval) {
                                item.icon = require("/public/homeImg/icon_jqz_n.png")
                            }
                        })
                        this.map.add(this.searchlist)
                        this.setLocation()
                        // this.inpval = ""
                    } else {
                        this.$message("请输入正确名称")
                    }
                }
        },
     
        Drivings(plate,startTime,endTime,pno) {
            this.$router.push({
                path: "/member/cheliangguiji",
                query: {
                    plate: plate,
                    gmtCreate:startTime,
                    gmtModified:endTime,
                    pno,
                }
            })
        },
        async carMap() {
            const Data = await AMapLoader.load({
                key: "e1e067886b395ac1aa709c2dd9982e7a", // 申请好的Web端开发者Key，首次调用 load 时必填
            })
            window.calcDriving = (plate) => {

                this.calcDriving(plate);

            };
            this.map = new Data.Map("container", {
                viewMode: "3D", // 是否为3D地图模式
                zoom: 11, // 初始化地图级别
                center: [this.lng, this.lat], // 初始化地图中心点位置
            })
            const markerObj = new Data.Marker({
                position: [this.lng, this.lat],
                title: this.positioncar.plate,
                icon: require("/public/homeImg/icon_truck_blue.png"),
                map: this.map,

            })
            this.map.add(markerObj)
            this.infoWindow = new AMap.InfoWindow({
                position: [this.lng, this.lat],
                // offset: new AMap.Pixel(20, -10),
                content: `<div class="map-info" style="font-size:80%;padding:10px 25px 10px 10px">
						<div class="info-item">
						<span>车牌号:</span>
						<span>${this.positioncar.plate || "--"}</span>
						</div>
						<div class="info-item" style="margin-bottom: 10px;">
						<span>车辆状态:</span>
						<span>${this.positioncar.vehstate || "--"}</span>
						</div>
                        <div class="info-item" style="margin-bottom: 10px;">
						<span>剩余电量:</span>
						<span>${this.positioncar.soc || "--"}%</span>
						</div>
						<div class="info-item" style="margin-bottom: 10px;">
						<span>车辆类型:</span>
						<span>${this.positioncar.cartype || "--"}</span>
						</div>
						<div class="info-item" style="margin-bottom: 10px;">
						<span>排放标准:</span>
						<span>${this.positioncar.discharge || "--"}</span>
						</div>
						<div class="info-item" style="margin-bottom: 20px;">
						<span>所属车队:</span>
						<span>${this.positioncar.shortname || "--"}</span>
						</div>
						<div class="line"></div>
						<el-button type="primary" 
                       style="background: linear-gradient(0deg, #28C0C7 0%, #33D9A4 100%);cursor: pointer; border-radius: 5px; color: #fff;padding: 5px 10px;font-size: 14px;" onClick="calcDriving('${this.positioncar.plate}')">查看车辆轨迹 ></el-button>
					</div>`,
            });
            let _this = this
            markerObj.on("click", function () {
                _this.infoWindow.open(_this.map);
            });
            // this.map.setFitView(null, false);

        },
        calcDriving(plate) {
            this.$router.push({
                path: "/member/cheliangguiji",
                query: {
                    plate: plate
                }
            })
        }
    },
}
</script>

<style lang="scss" scoped>
.mapdetail {
    width: 100%;
    height: 100%;
    position: relative;
    .map-title {
        padding:5px 20px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #fff;

        .inp {
            padding: 10px;
            border: 1px solid #17B6A1;
            border-radius: 5px;
            outline: none;
            background-color: #F8F9FB;
        }

        .search {
            margin-left: 20px;
            width: 80px;
            height: 30px;
            background: #17B6A1;
            border-radius: 8px;
            font-size: 80%;
            font-family: PingFang SC;
            font-weight: 400;
            color: #fff;
            text-align: center;
            //line-height: 32px;
            border: none;
        }
        .search1 {
            margin-left: 20px;
            width: 80px;
            height: 30px;
            background: #c00000;
            border-radius: 8px;
            font-size: 80%;
            font-family: PingFang SC;
            font-weight: 400;
            color: #fff;
            text-align: center;
            //line-height: 32px;
            border: none;
        }
    }
.platelist{
    width: 140px;
    // height: 300px;
    max-height: calc(100% - 180px);
    position: absolute;
    overflow: auto;
    left: 20px;
    z-index: 1;
    top: 100px;
    background-color: #fff;
    .liclass{
        line-height:40px ;
        cursor: pointer;
        padding: 0 20px;
        box-sizing: border-box;
    }
}
    // #container {
    //     height: calc(100% - 138px);
    // }
}
.map-info{
    width: 210px;
    height: 260px;
}
</style>